<ng-container *ngrxLet="singleTiimStudyParticipantVisible$ as singleTiimStudyParticipantVisible">
  <ng-container *ngIf="!singleTiimStudyParticipantVisible">
    <dashboard-loader
      *ngIf="(loadingTiimStudyParticipants$ | async) || (loadingSelectedStudy$ | async)"
      [title]="'Loading Participants...'"
    ></dashboard-loader>
    <div
      class="dashboard-tiim-study-participants"
      fxLayout="column"
      fxLayoutAlign="space-between stretch"
      *ngIf="(tiimStudyParticipantsLoaded$ | async) && (selectedStudyLoaded$ | async)"
    >
      <div class="dashboard-tiim-study-participants__header" fxLayout="row" fxLayoutAlign="space-between center">
        <div class="dashboard-tiim-study-participants__header-title">Participants</div>
      </div>
      <div *ngIf="!tiimStudyParticipants.length" class="dashboard-tiim-study-participants__message" fxLayout="column">
        No participants have been subscribed to this study.
      </div>
      <div
        class="dashboard-tiim-study-participants__category-holder"
        *ngFor="let category of tiimStudyParticipantsCategories"
      >
        <div
          class="dashboard-tiim-study-participants__category-inner"
          *ngIf="getCategoryTiimStudyParticipants(category).length"
        >
          <div class="dashboard-tiim-study-participants__category" fxLayout="row" fxLayoutAlign="space-between center">
            <div class="dashboard-tiim-study-participants__category-name">
              {{ category.name }}
            </div>
          </div>
          <div
            class="dashboard-tiim-study-participants__list"
            fxLayout="column"
            fxLayoutAlign="space-between stretch"
            fxLayoutGap="10px"
            *ngIf="selectedStudy"
          >
            <mat-card
              class="dashboard-tiim-study-participants__list-item"
              fxLayout="row"
              fxLayoutAlign="space-between center"
              *ngFor="let tiimStudyParticipant of getCategoryTiimStudyParticipants(category)"
              dashboardStudyTypeColor
              [studyType]="selectedStudy?.type"
              (click)="openParticipantDetails(tiimStudyParticipant)"
            >
              <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="25px">
                <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="6px">
                  <label class="dashboard-tiim-study-participants__list-item-id">
                    {{ tiimStudyParticipant?.participant.id }}&#x0002E;
                  </label>
                </div>
                <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="6px">
                  <label class="dashboard-tiim-study-participants__list-item-title">
                    {{ tiimStudyParticipant?.participant.firstname + ' ' + tiimStudyParticipant?.participant.lastname }}
                  </label>
                </div>
              </div>
              <mat-icon
                class="dashboard-tiim-study-participants__list-item-delete"
                #tooltip="matTooltip"
                matTooltip="Remove this participant"
                matTooltipPosition="above"
                (click)="
                  $event.stopPropagation();
                  deleteTiimStudyParticipant(
                    selectedStudy?.id,
                    tiimStudyParticipant?.participant.id,
                    tiimStudyParticipant?.id
                  )
                "
                *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.PARTICIPANTS, PRIVILEGE_ACTIONS.ALL)"
              >
                delete
              </mat-icon>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
  <dashboard-tiim-study-participant *ngIf="singleTiimStudyParticipantVisible"></dashboard-tiim-study-participant>
</ng-container>
